



 import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
 import AgroGenericCard from "@/components/agroGenericCard/AgroGenericCard.vue";
 import * as analysesApi from "@/api/analyses";
 import { ProcessingCount } from "@/api/analyses/types";

 @Component({
   name: 'CardProcessingCountController',
   components: {
     AgroGenericCard,
   }
 })

export default class CardProcessingCountController extends Vue {
  private isLoading = false;
  private count: number | null = null;

  @Prop({ type: Boolean, default: false }) private onlyUserFarms!: boolean;
  @Prop({ type: Boolean, default: false }) private onlyActiveMonitoring!: boolean;

  async mounted() {
    await this.getCountFarm();
  };

  @Watch('onlyUserFarms')
  private async getCountFarm() {
    this.isLoading = true;
    try {
      const response = (await analysesApi.getProcessingCount(this.onlyUserFarms)).data;
      this.count = response.processingTotal;
    } catch {
      this.count = null;
    } finally {
      this.isLoading = false;
    }
  }
  
}
